'use strict';

angular.module('licensure.services')
    .factory('Positions', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/positions', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        var getServicePositions = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/positions/servicePositions', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
            });

            return d.promise;
        }

        return {
            get: get,

            getServicePositions: getServicePositions,

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/positions/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getServiceDesignation: function (args) {
                if (args == null) {
                    args = {};
                }

                if (args.service_id === undefined || args.service_id === null) {
                    return get(angular.extend({}, args, { service_designation: true }));
                }
                else {
                    return getServicePositions(angular.extend({}, args, { service_designation: true }));
                }
            },
        }
    }])
;